/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the client used to communicate with the API.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * The client used to make typed API calls.
 */
import { JsonServiceClient } from '@servicestack/client';

/**
 * Used for request state enumeration
 */
import { RequestState } from '@ngt/request-utilities';

import { BctApiPermissionsActions } from '@ngt/online-patient-management-bctapi-permissions';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/**
 * The redux store.
 */
import { store } from '..';

/**
 * Used to check on the state of the authenticatedUser
 */
import { AuthenticatedUserActions, IAuthenticatedUserState } from '../store/modules/authenticatedUser';

import { LOGIN_LINK } from '../constants/authentication';

/*
 * ---------------------------------------------------------------------------------
 * Types
 * ---------------------------------------------------------------------------------
 */
declare let global: any; // populated from package.json/jest

if (typeof global === 'undefined') {
    (window as any).global = window;
}

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const client = new JsonServiceClient(global.BaseUrl || '/');

client.responseFilter = (res: Response) => {
    const state = store.getState() as IAuthenticatedUserState;

    if (res.headers.has('openiddict-user-status') &&
        res.headers.get('openiddict-user-status') === 'unauthenticated' &&
        state.authenticatedUser.user) {
            store.dispatch(AuthenticatedUserActions.signoutAuthenticatedUser())
    }
    else if (res.headers.has('openiddict-user-update') &&
        res.headers.get('openiddict-user-update') === 'true' &&
        state.authenticatedUser.loadState.state !== RequestState.Pending) {
        console.log('user updated');
        console.log(res);
        store.dispatch(AuthenticatedUserActions.checkAuthenticatedUser())
        store.dispatch(BctApiPermissionsActions.refresh());
    }
}

client.exceptionFilter = (res: Response, error: any) => {
    if (res.status === 401) {
        global.location.href = LOGIN_LINK + '?redirect=' + encodeURIComponent(global.location.pathname + global.location.search);
    }
};

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default client;